import dayjs from 'dayjs';
import i18n from './i18n';

export const formatDate = (d?: string | null) => (d ? dayjs(d).format('DD/MM/YYYY') : '—');
export const formatDateTime = (d?: string | null) =>
  d ? dayjs(d).format('DD/MM/YYYY HH:mm') : '—';
export const today = () => dayjs().format('YYYY-MM-DD');

/** Case- and accent-insensitive match used by the table search boxes. */
export function matches(text: string | null | undefined, query: string): boolean {
  if (!query) return true;
  const norm = (s: string) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  return norm(text ?? '').includes(norm(query));
}

// fr-FR groups thousands with a space; fr-MA uses a dot, which reads as a decimal point
const NUMBER_LOCALES: Record<string, string> = { fr: 'fr-FR', ar: 'ar-MA', en: 'en-GB' };

/** Number in the user's language (thin spaces as thousands separator in French). */
export function formatNumber(
  value: number | string | null | undefined,
  maximumFractionDigits = 3,
): string {
  if (value === null || value === undefined || value === '') return '—';
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  const locale = NUMBER_LOCALES[i18n.language.slice(0, 2)] ?? 'fr-FR';
  return new Intl.NumberFormat(locale, { maximumFractionDigits }).format(n);
}

/** An amount in dirhams, with its two decimals (costs, FR-SUI-10). */
export function formatMoney(value: number | string | null | undefined): string {
  if (value === null || value === undefined || value === '') return '—';
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  const locale = NUMBER_LOCALES[i18n.language.slice(0, 2)] ?? 'fr-FR';
  const amount = new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n);
  return i18n.t('costs.money', { amount });
}
